<!--
component: BrowseKanhatsu
author: Ken Nakamura
description: 開発登録簿閲覧画面
-->
<template>
  <section class="browse-kaihatsu">
    <v-container fluid >
      <v-row>
      <div class="split">
        <div class="split left-box">
          <v-container fluid>
            <v-row>
              <ZoomCanvas id="zoom-area" width="300" heigth="200"
                style="margin:5px;"
                :sourceImage="image" :zoom="zoomScale"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-if="useCanvas"
              />
              <ZoomImageViewer id="zoom-area" width="300" height="200"
                :imageUrl="imageUrl" :sourceWidth="imageWidth" :sourceHeight="imageHeight"
                :zoom="zoomScale"
                :centerx="zoomCenterX" :centery="zoomCenterY"
                v-else
              />
            </v-row>
            <v-row>
              <v-col v-for="(page, index) in pages" :key="index"
                cols="12" md="12" lg="12" xl="6" style="margin:0px; padding:0;">
                <v-btn
                  @click="showPage(index)"
                  large width="95%"
                  class="lighten-3 text-h6 ml-1 my-2 blue"
                  :class="{yellow: pageNo==index}" >
                  {{ page.image.title }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense class="mt-3 mb-1">
              <v-col cols=6>
              <v-btn @click="zoomIn()"
                light x-large
                class="text-h5 mx-1 my-3">
                <v-icon color="#55aaff" class="ma-auto">mdi-plus-circle</v-icon>
                拡大
              </v-btn>
              </v-col>
              <v-col>
              <v-btn @click="zoomOut()"
                light x-large
                class="text-h5 mx-1 my-3">
                <v-icon color="#ccaa55" class="ma-auto">mdi-minus-circle</v-icon>
                縮小
              </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols=12>
                <v-btn @click="printKaihatsu()"
                  dark color="#bb5577" x-large width="90%"
                  class="text-h5 mx-2 mt-2 mb-1">
                  <v-icon color="#dddddd" class="mx-1">mdi-printer</v-icon>
                  印刷
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="split right-box">
          <ImageCanvas id="image-viewer"
            width="100%" height="100%"
            :imageUrl="imageUrl"
            :imageScale="imageScale"
            :mouseClick="onImageClick"
            @loaded="imageLoaded"
            @scaleChanged="imageScaleChanged"
            @imgMoved="imageMoved"
            v-if="useCanvas"
          />
          <ImageViewer id="image-viewer" :imageUrl="imageUrl"
            :scaleSize="scaleSizeReset"
            :mouseClick="onImageClick"
            @updateScaleSize="scaleSize = $event"
            @imgMoved="imageMoved" @imgLoaded="imageLoaded" @mouseMove="mouseMove"
            width="100%"
            v-else
          />
        </div>
      </div>
      </v-row>
			<Dialog error :open="notfound" :ok="back" 
        :title="dialogTitle"
        :body="dialogMessage"/>
    </v-container>
  </section>
</template>

<script>
import ImageViewer from '../components/ImageViewer.vue';
import ZoomImageViewer from '../components/ZoomImageViewer.vue'
import ImageCanvas from '../components/ImageCanvas.vue';
import ZoomCanvas from '../components/ZoomCanvas.vue';
import { dbglog } from '../common/utils';
import { loadKaihatsu, loadTakuzo } from '../common/apiAccess';
import Dialog from '../components/Dialog.vue'

export default {
  components: {
    ImageViewer,
    ZoomImageViewer,
    ImageCanvas,
    ZoomCanvas,
		Dialog,
  },
  data() {
    return {
      useCanvas: true,
      pages: [],
      pageNo: 0,
      scaleSize: 1,
      notfound: false,
      dialogTitle: '',
      dialogMessage: '',
      image: null,    // オリジナル画像オブジェクト
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      imgX: 0,        // ImageViewerのimg要素左位置
      imgY: 0,        // ImageViewerのimg要素上位置
      cursorX: 0,     // ImageViewer画像上のマウスカーソルX座標
      cursorY: 0,     // ImageViewer画像上のマウスカーソYX座標
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
      imageScale: 1,  // ImageCanvasに渡す画像拡大率（画面横幅いっぱいを1とする）
    }
  },
  props: {
    id: {
      type: Number,
      default: 0,
    },
    target: {
      type: Number,
      default: -1,
    },
    zoomRatio: {
      type: Number,
      default: 2,
    },
    zoomOnMove: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    scaleSize: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
        this.zoomCenterX = this.cursorX;
        this.zoomCenterY = this.cursorY;
      }
    },
    imageScale: {
      immediate: true,
      handler(value) {
        this.zoomScale = value * this.viewerRatio * this.zoomRatio;
      }
    },
  },
  mounted () {
    if (this.unauthorized) {
      this.message = 'ユーザー認証されていません。';
      this.$router.replace('/');
    }

    const imgviewer = document.getElementById('image-viewer');
    const zoomimg = document.getElementById('zoom-area');
    this.viewerRatio = imgviewer.offsetWidth / zoomimg.offsetWidth;
    if (this.useCanvas) {
      this.zoomScale = this.imageScale * this.viewerRatio * this.zoomRatio;
    }
    else {
      this.zoomScale = this.scaleSize * this.viewerRatio * this.zoomRatio;
    }

    if (this.id !== undefined && this.id != '') {
      this.$store.commit('setGaiyoId', this.id);
    }
    let targetType = this.$store.state.searchTargetType;
    if (this.target >= 0) {
      targetType = this.target;
    }
    this.$store.commit('setSearchTargetType', targetType);

    if (targetType == 0) {
      loadKaihatsu(this.$store.state.gaiyoId, (data) => {
        if (data !== null && data.pages !== undefined) {
          dbglog(`BrowseKaihatsu.mounted: ${data.pages.length}`);
          this.message = `開発許可番号 : ${data.kyokaNo}`;
          this.dialogTitle="開発登録簿検索";
          //this.dialogMessage="開発登録簿データが存在しません。なお閲覧できないものについてはご相談ください。";
          this.dialogMessage="開発登録簿データがありません。";
          if (data.pages.length == 0) {
            this.notfound = true;
            this.pages = [];
          }
          else {
            this.pages = data.pages;
            if (this.imageUrl == '') {
              this.notfound = true;
            }
          }
        }
      });
    }
    else {
      loadTakuzo(this.$store.state.gaiyoId, (data) => {
        if (data.errorCode) {
          console.log(data.errorCode);
        }
        if (data !== null && data.pages !== undefined) {
          dbglog(`loadTakuzo: data = ${data}`);
          // フッターに表示するメッセージを設定
          if ((data.kyokaNo.includes('宅規'))
            ||(data.kyokaNo.includes('森規'))
            ||(data.kyokaNo.includes('農規'))
            ||(data.kyokaNo.includes('土規'))) {
            this.message = `盛土規制法許可番号 : ${data.kyokaNo}`;
            this.dialogTitle="盛土規制法検索";
            this.dialogMessage="盛土規制法データがありません。";
            if (data.pages.length == 0) {
              this.notfound = true;
              this.pages = [];
            } else {
              this.pages = data.pages;
              if (this.imageUrl == '') {
                this.notfound = true;
              }
            }
          } else {
            this.message = `宅造許可番号 : ${data.kyokaNo}`;
            this.dialogTitle="宅造検索";
            this.dialogMessage="宅造データがありません。";
            if (data.pages.length == 0) {
              this.notfound = true;
              this.pages = [];
            } else {
              this.pages = data.pages;
              if (this.imageUrl == '') {
                this.notfound = true;
              }
            }
          }
          // 図面ボタンのタイトルを設定
          if (data.kyokaNo.includes('土規')) {
            this.pages.forEach((page, index) => {
              page.image.title = '土石の堆積計画平面図' + (index+1);
            });
          } else {
            this.pages.forEach((page, index) => {
              page.image.title = '造成計画平面図' + (index+1);
            });
          }
        }
      });
    }
  },
  computed: {
    token () {
      return this.$store.state.token;
    },
    unauthorized () {
      return this.token === undefined || this.token === null ||
        this.token.length === undefined || this.token.length == 0;
    },
    authorized () {
      return !this.unauthorized;
    },
    imageUrl () {
      if (this.pages === null || this.pages.length === undefined ||
          this.pages.length <= this.pageNo || this.pages[this.pageNo].image === undefined) {
        return '';
      }
      else {
        const page = this.pages[this.pageNo];
        return page.image.url;
      }
    },
    scaleSizeReset() {
      return this.scaleSize;
    },
    message: {
      get() { return this.$store.state.message; },
      set(val) { this.$store.commit('setMessage', val) }
    },
  },
  methods: {
    showPage (no) {
      this.pageNo = no;
      this.scaleSize = 1;
    },
    zoomIn () {
      if(this.scaleSize < 10){
        this.scaleSize += 1;
      }
      this.imageScale *= 1.5;
    },
    zoomOut () {
      if(this.scaleSize > 1){
        this.scaleSize -= 1;
      }
      //if (this.imageScale > 1) {
        //this.imageScale = Math.max(1, this.imageScale / 1.5);
        this.imageScale = Math.max(1/2, this.imageScale / 1.5);
      //}
    },
    printKaihatsu () {
      const images = [ this.imageUrl ];
      const paper = (this.pages[this.pageNo].image.title == '土地利用計画図') ? 'A3R' : 'A4';
      this.$router.push({name:'print-image', params:{images:images, paper:paper}});
      /*
      if (this.pages !== null && this.pages.length !== undefined && this.pages.length > 0) {
        let images = [];
        for (let i = 0; i < this.pages.length; i++) {
          const page = this.pages[i];
          if (page !== null && page.image !== undefined) {
            images.push(page.image.url);
          }
        }
        this.$router.push({name:'print-image', params:{images:images}});
      }
      */
    },
    back() {
      this.$router.back();
    },
    imageLoaded(param) {
      if (param) {
        if (this.useCanvas) {
          this.image = param;
          this.imageWidth = param.width;
          this.imageHeight = param.height;
          this.imageScale = 1;
        }
        else {
          this.imageWidth = param.srcw;
          this.imageHeight = param.srch;
        }
      }
    },
    imageMoved(param) {
      this.imgX = param.x;
      this.imgY = param.y;
    },
    imageScaleChanged(scale) {
      this.imageScale = scale;
    },
    mouseMove(param) {
      this.cursorX = param.x;
      this.cursorY = param.y;
      if (this.zoomOnMove) {
        this.zoomCenterX = param.x;
        this.zoomCenterY = param.y;
      }
    },
    onImageClick(x, y) {
      if (this.useCanvas) {
        this.zoomCenterX = x;
        this.zoomCenterY = y;
      }
      else {
        this.zoomCenterX = x;
        this.zoomCenterY = y + 55;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.split {
  position: absolute;
  width: 100%;
  height: calc(100% - 4px);
  padding: 0;
  margin: 0;
}
.left-box {
  left: 0;
  width: 320px;
  height: calc(100% - 16px);
  padding: 0.3em;
  overflow-y: auto;
}
.right-box {
  right: 0;
  width: calc(100% - 320px);
  height: calc(100% - 16px);
  padding: 0;
  overflow: hidden;
  background-color: rgb(198, 226, 225);
}
.active {
  background-color: aquamarine;
}
#zoom-area {
  width: 300px !important;
  height: 200px !important;
  background-color: white;
	overflow: hidden;
}
@media print {
  .left-box {
    visibility: hidden;
    width: 0%;
  }
  .right-box {
    width: 100%;
    overflow-y: auto;
  }
}
</style>